import dynamic from 'next/dynamic';
import styled from 'styled-components';

const Lottie = dynamic(() => import('lottie-react'), { ssr: false });

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  height: 100%;
`;

export const GoatPen = styled.div`
  position: relative;
`;

export const GoatFood = styled.div`
  color: #008080;
  font-size: 300px;
  line-height: 280px;
  font-weight: 600;
`;

export const LottieContainer = styled(Lottie)`
  height: 280px;
  margin-top: -230px;
`;

export const RedirectText = styled.p`
  font-size: 24px;
`;
